import React from "react";
import  './Resources/Actions.css';
import Navbar from "./navbar";
import { useNavigate } from "react-router-dom";
import './App.css';

export default function Loandetails(){
    const navigate = useNavigate();
    const user = localStorage.getItem("utype");
    const APP_NAME = process.env.REACT_APP_NAME;

    return(
        <>
       
       <div style = {{height:"100%", width:"100%"}}>
            <div className="reportheader">{APP_NAME} </div>
            <div className="subheader">Reports </div>
            <Navbar/>
        <div className="styles" style ={{marginTop:"30px"}} onClick={()=>{navigate('/customerledger')}}>Customer Loan Ledger</div>
        <div className="styles" style ={{marginTop:"30px"}} onClick={()=>{navigate('/dailycollection')}}>Daily Collection Report</div>
        <div className="styles" style ={{marginTop:"30px"}} onClick={()=>{navigate('/dailyloanlist')}}>Daily Loan Report</div>
        <div className="styles" style ={{marginTop:"30px"}} onClick={()=>{navigate('/expensesreport')}}>Expenses Report</div>
        
        {user === "1" ? <>
        {/* <div className="styles" style ={{marginTop:"30px"}} onClick={()=>{navigate('//userdayclosing')}}>Daily Closing Report</div> */}
        
        <div className="styles" style ={{marginTop:"30px"}} onClick={()=>{navigate('/interestreport')}}>Interest Report</div>
        <div className="styles" style ={{marginTop:"30px"}} onClick={()=>{navigate('/finereport')}}>Fine Report</div>
        <div className="styles" style ={{marginTop:"30px"}} onClick={()=>{navigate('/expectingdue')}}>UpComingDue Report</div>
        <div className="styles" style ={{marginTop:"30px"}} onClick={()=>{navigate('/defaulters')}}>Defaulters Report</div>
        <div className="styles" style ={{marginTop:"30px",marginBottom:"45px"}} onClick={()=>{navigate('/balancereport')}}>Overall Balance Report</div>
        {/*<div className="styles" style ={{marginTop:"30px"}} onClick={()=>{navigate('/cashinhand')}}>Cash Balance</div>*/}
        </>
        :
        <>
        <div className="styles" style ={{marginTop:"30px"}} onClick={()=>{navigate('/userdayclosing')}}>Closing Summary</div>
        </>}
        <div className="backbutton" onClick={()=>{user === "1" ?navigate('/accounts') : navigate('/home')}}>Back</div>
        <div style={{backgroundColor:"lightskyblue",width:"100%",height:"40%"}}></div>
        </div>
       
        </>
    )
}